import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#008D7B', dark: '#007566', light: '#E1F7F3', contrastText: '#FFFFFF' },
    secondary: { main: '#173057', dark: '#102449', light: '#E8EDF5', contrastText: '#FFFFFF' },
    background: { default: '#F8FAFB', paper: '#FFFFFF' },
    text: {
      primary: '#102449',
      secondary: '#52637C',
      disabled: '#8A98A9',
    },
    success: { main: '#18875D' },
    info: { main: '#008D7B' },
    divider: '#DCE6EC',
  },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontWeight: 900, letterSpacing: 0, lineHeight: 1 },
    h2: { fontWeight: 900, letterSpacing: 0, lineHeight: 1.08 },
    h3: { fontWeight: 800, letterSpacing: 0, lineHeight: 1.15 },
    h4: { fontWeight: 800, letterSpacing: 0, lineHeight: 1.2 },
    h5: { fontWeight: 800, letterSpacing: 0 },
    h6: { fontWeight: 800, letterSpacing: 0 },
    button: { textTransform: 'none', fontWeight: 800, letterSpacing: 0 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    'none',
    '0 2px 12px rgba(16,36,73,.06)',
    ...Array(23).fill('0 2px 12px rgba(16,36,73,.06)'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 800,
          fontSize: 15,
          boxShadow: 'none',
          padding: '10px 20px',
          '&:hover': {
            boxShadow: 'none',
          },
          textTransform: 'none',
        },
        contained: {
          backgroundColor: '#008D7B',
          color: '#FFFFFF',
          '&:hover': {
            backgroundColor: '#007566',
          },
        },
        outlined: {
          borderColor: '#008D7B',
          color: '#008D7B',
          '&:hover': {
            backgroundColor: '#E1F7F3',
            borderColor: '#007566',
            color: '#007566',
          },
        },
        text: {
          color: '#008D7B',
          '&:hover': {
            backgroundColor: '#E1F7F3',
            color: '#007566',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 12px rgba(16,36,73,.06)',
          backgroundColor: '#fff',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#fff',
          boxShadow: '0 2px 12px rgba(16,36,73,.06)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
          backgroundColor: '#F1F7F7',
          color: '#173057',
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#173057',
          color: '#fff',
          fontWeight: 700,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#173057',
          fontWeight: 600,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#FFFFFF',
        },
        notchedOutline: {
          borderColor: '#DCE6EC',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#FFFFFF',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#173057',
          borderRadius: 0,
          boxShadow: '0 1px 0 rgba(16,36,73,.08)',
        },
      },
    },
  },
  demoMoverImages: [
    '/assets/img/property/01.jpg',
    '/assets/img/property/02.jpg',
    '/assets/img/property/03.jpg',
    '/assets/img/property/04.jpg',
  ],
});

export default theme;
